import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { BackButton } from "@/components/BackButton";
import { StarField } from "@/components/alignment/StarField";
import { Seo } from "@/components/Seo";
import { SITE_URL } from "@/lib/siteConfig";
import { GAMES } from "@/data/games";
import { ArrowRight } from "lucide-react";

export default function MindfulArcade() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "InnerArcade Mindful Games",
    itemListElement: GAMES.map((g, i) => ({
      "@type": "ListItem",
      position: i + 1,
      url: `${SITE_URL}/games/${g.slug}`,
      name: g.name,
    })),
  };

  return (
    <div className="min-h-screen relative text-slate-200 overflow-hidden" data-testid="mindful-page">
      <Seo
        title="Free Mindful Browser Games — Trivia, Breathing & Casual | InnerArcade"
        description="Play free mindful browser games: Wisdom Rush trivia, Calm Current breathing, and Karma Garden. No download, quick sessions, and every round earns Journey XP."
        path="/mindful"
        keywords="free browser games, mindful games for adults, trivia game, breathing game, casual game online, quick games to play"
        jsonLd={jsonLd}
      />
      <div className="absolute inset-0" style={{ background: "radial-gradient(1000px 600px at 15% -10%, rgba(37,52,120,0.55), transparent 60%), radial-gradient(900px 700px at 90% 0%, rgba(88,28,135,0.45), transparent 60%), linear-gradient(180deg,#070512,#0A0A14)" }} />
      <StarField color="#A78BFA" />
      <div className="relative z-10">
        <Header />
        <div className="max-w-5xl mx-auto px-6 py-12">
          <BackButton className="mb-6" />
          <p className="text-sm tracking-[0.3em] uppercase text-violet-300/80 mb-3">Mindful Arcade</p>
          <h1 className="font-head font-900 text-4xl sm:text-5xl text-slate-50 leading-[0.95] mb-3">GAMES WITH HEART</h1>
          <p className="text-slate-400 max-w-xl mb-10 text-base">Short games that reinforce calm attention, discernment, and kindness. Free to play — every round earns Journey XP.</p>

          <div className="grid sm:grid-cols-3 gap-5" data-testid="mindful-grid">
            {GAMES.map((g) => {
              const Icon = g.icon;
              return (
                <Link key={g.id} to={`/games/${g.slug}`} data-testid={`mindful-card-${g.id}`}
                  className="group text-left rounded-2xl border p-6 hover:-translate-y-1 transition-transform duration-300"
                  style={{ borderColor: `${g.color}44`, background: `${g.color}0d` }}>
                  <Icon className="w-8 h-8 mb-4" style={{ color: g.color }} />
                  <h3 className="font-head font-700 text-xl text-slate-50 mb-1">{g.name}</h3>
                  <p className="text-xs uppercase tracking-wider mb-3" style={{ color: g.color }}>{g.tagline}</p>
                  <p className="text-sm text-slate-400 leading-relaxed">{g.short}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ color: g.color }}>Play now <ArrowRight className="w-4 h-4" /></span>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
